import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import BottomNav from "./components/BottomNav";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminRoute from "./components/AdminRoute";
import ErrorBoundary from "./components/ErrorBoundary";
import { AuthProvider } from "./context/AuthContext";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Home from "./pages/Home";
import Toronto from "./pages/Toronto";
import Show from "./pages/Show";
import Log from "./pages/Log";
import Saved from "./pages/Saved";
import Profile from "./pages/Profile";
import Lists from "./pages/Lists";
import ListDetail from "./pages/ListDetail";
import AddShow from "./pages/AddShow";
import SuggestCredits from "./pages/SuggestCredits";
import User from "./pages/User";
import Notifications from "./pages/Notifications";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminShows from "./pages/admin/AdminShows";
import AdminCredits from "./pages/admin/AdminCredits";
import AdminInvites from "./pages/admin/AdminInvites";
import AdminReports from "./pages/admin/AdminReports";
import AdminImport from "./pages/admin/AdminImport";
import AdminUpkeep from "./pages/admin/AdminUpkeep";

// stable reference — toaster mounts once, no re-render
const TOASTER_OPTIONS = {
  style: {
    background: "#000",
    border: "2px solid #9cff00",
    color: "#fff",
    borderRadius: 0,
    fontFamily: "'IBM Plex Mono', monospace",
    fontSize: "12px",
    textTransform: "lowercase",
    letterSpacing: "0.02em",
  },
};

function App() {
  return (
    <div className="App bg-black min-h-screen">
      <BrowserRouter>
        <ErrorBoundary>
          <AuthProvider>
            <Routes>
            {/* public */}
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />

            {/* protected */}
            <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
            <Route path="/toronto" element={<ProtectedRoute><Toronto /></ProtectedRoute>} />
            <Route path="/show/:id" element={<ProtectedRoute><Show /></ProtectedRoute>} />
            <Route path="/show/:id/suggest-credits" element={<ProtectedRoute><SuggestCredits /></ProtectedRoute>} />
            <Route path="/log" element={<ProtectedRoute><Log /></ProtectedRoute>} />
            <Route path="/log/:showId" element={<ProtectedRoute><Log /></ProtectedRoute>} />
            <Route path="/saved" element={<ProtectedRoute><Saved /></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
            <Route path="/lists" element={<ProtectedRoute><Lists /></ProtectedRoute>} />
            <Route path="/list/:id" element={<ProtectedRoute><ListDetail /></ProtectedRoute>} />
            <Route path="/add" element={<ProtectedRoute><AddShow /></ProtectedRoute>} />
            <Route path="/user/:username" element={<ProtectedRoute><User /></ProtectedRoute>} />
            <Route path="/notifications" element={<ProtectedRoute><Notifications /></ProtectedRoute>} />

            {/* admin */}
            <Route path="/admin" element={<AdminRoute><AdminLayout /></AdminRoute>}>
              <Route index element={<AdminShows />} />
              <Route path="shows" element={<AdminShows />} />
              <Route path="import" element={<AdminImport />} />
              <Route path="upkeep" element={<AdminUpkeep />} />
              <Route path="credits" element={<AdminCredits />} />
              <Route path="invites" element={<AdminInvites />} />
              <Route path="reports" element={<AdminReports />} />
            </Route>
          </Routes>
          <BottomNav />
          <Toaster position="top-center" toastOptions={TOASTER_OPTIONS} />
        </AuthProvider>
        </ErrorBoundary>
      </BrowserRouter>
    </div>
  );
}

export default App;
